<template>
  <Modal :visible="visible" @close="onClose">
    <template #header>
      <p class="modalTitle">Confirm Cancellation</p>
    </template>
    <template #body>
      <p>Do you want to cancel this reservation?</p>
    </template>
    <template #footer>
      <div class="btnWrap">
        <button @click="onClose" class="submit-button cancelBtn">Close</button>
        <button @click="onConfirm" class="submit-button">Cancel Reservation</button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import api from "@/services/api";

export default {
  name: "CancelSeatModal",
  components: { Modal },
  props: {
    visible: { type: Boolean, required: true },
    reservationId: { type: Number, default: null },
  },
  methods: {
    async onConfirm() {
      try {
        await api.delete(`/seats/reservations/${this.reservationId}/cancel/`);
        this.$emit("confirmed");
      } catch (e) {
        console.error("Failed to cancel:", e);
        alert("Failed to cancel the reservation.");
      }
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style>
    .modal-header, .modal-footer{
        padding: 0!important;
        border-bottom: none !important;
    }
    .modal-container{
        padding: 2rem;
    }
</style>
<style>
    .modal-header, .modal-footer{
        padding: 0!important;
        border-bottom: none !important;
    }
    .modal-container{
        padding: 2rem;
    }
</style>
<style scoped>
p {
  margin: 1em 0;
}
.btnWrap {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}
.modalTitle{
    font-size: 20px;
    color: var(--blue);
    font-weight: 600;
    text-align: center;
    margin:0;
    & span{
        font-size: 0.9em;
    }
}
.submit-button {
    background: var(--gradCan);  
    width: 100%;
    max-width: 300px;
    padding: 1rem;
    border: none;
    color: white;
    border-radius: 10px;
    margin: 0;
    display: block;

    &.cancelBtn{
        background: none;
        border: 1px solid var(--blue);
        color: var(--blue);
        max-width: 150px;
        margin-right: 1rem;
    }

    .submit-button:disabled {
        background: #cccccc;
        cursor: inherit;
    }
}
</style>
